import type { ElementType, ReactNode } from 'react';
import { cx } from './cx';

// Rediseño · Bloque A. Encabezado pequeño de una sección o de una tarjeta: título, una línea de
// apoyo opcional y una acción opcional a la derecha. El encabezado de PÁGINA sigue siendo
// `PageHeader`; este es el que va dentro.
export interface SectionHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Un botón o un enlace («Ver todo»). */
  action?: ReactNode;
  /** Nivel del encabezado en el documento. No cambia el tamaño: mantiene el orden h1 → h2 → h3. */
  level?: 2 | 3 | 4;
  className?: string;
}

export function SectionHeader({ title, description, action, level = 2, className }: SectionHeaderProps) {
  const Heading: ElementType = `h${level}`;
  return (
    <div className={cx('n3-section-header', className)}>
      <div className="n3-section-header__text">
        <Heading className="n3-section-header__title">{title}</Heading>
        {description && <p className="n3-section-header__description">{description}</p>}
      </div>
      {action && <div className="n3-section-header__action">{action}</div>}
    </div>
  );
}
